/**
 * @overview 教室 新增/编辑
 * @author jzhu
 * @date 2020-5-27
 */

import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
let { WizContainer, modelUtils } = framework_tool
let { WizCard, WizForm, WizSpin, WizRow, WizCol, WizButton } = component_tool
let { Session } = utils_tool
import { createColumns } from './columns'

const getParamRecord = (history) => {
    let record = {}
    if (history.location && history.location.pathname === '/face/classroom/classroomUpd') {
        if (history.location.record) {
            record = history.location.record
            Session.set('classroom', record)
        } else {
            record = Session.get('classroom') || {}
        }
    }
    return record
}

class ClassroomDetail extends WizContainer {

    componentName = 'ClassroomDetail'

    constructor(props) {
        super(props)
        let { history } = props
        this._classroom = getParamRecord(history)
        this.state = {

        }
    }

    _componentDidMount = () => {
        this.doAction({
            path: 'trainCenter/info',
            payload: {
                key: 'classroom@trainCenterList',
                apiParams: {}
            }
        })
    }

    propsAndStateOnChange = {
        save: this._saveOnChange.bind(this)
    }

    _saveOnChange(nextProps, nextState) {
        if (nextProps.save.code === 1) {
            this.jumpPage('push', '/face/classroom')
        } else {
            wizNotice.error(nextProps.save.msg || '操作失败,请稍后尝试')
        }
        return true
    }

    _getDict = (data) => {
        let result = []
        if (data && data.length) {
            data.forEach(o => {
                result.push({ code: o.id, codeName: o.name })
            })
        }
        return result
    }

    _onSubmit = (values, record) => {
        let action = values.id ? 'update' : 'create'
        this.doAction({
            path: 'classroom/' + action,
            payload: {
                key: action + '_classroom_' + (values.id || ''),
                apiParams: { ...values }
            }
        })
    }

    _onReset() {
        this.refs.form && this.refs.form.resetFields && this.refs.form.resetFields()
    }

    _renderFooter = () => {
        return (
            <WizRow className='form-btns col-item'>
                <WizCol span={24}>
                    <WizButton title='保存' icon='check' type='primary' htmlType='submit'>保存</WizButton>
                    <WizButton title='重置' icon='reload' onClick={e => this._onReset()}>重置</WizButton>
                </WizCol>
            </WizRow>
        )
    }

    _render() {
        let { data } = this.props.trainList
        let datas = {
            record: this._classroom,
            dict: this._getDict(data)
        }
        let formProps = {
            ref: 'form',
            columns: createColumns(this, datas),
            record: this._classroom,
            onSubmit: this._onSubmit,
            footer: this._renderFooter(),
            formItemLayout: {
                labelCol: { span: 4 },
                wrapperCol: { span: 17 }
            }
        }
        let title = this._classroom.id ? '编辑教室' : '新增教室'
        return (
            <WizCard>
                <WizSpin tip={'加载中'} spinning={this.props.trainCenterLoading}>
                    <WizForm className={'form-inline'} {...formProps} />
                </WizSpin>
            </WizCard>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    let { classroom, trainCenter } = state
    const record = getParamRecord(ownProps.history)
    let key = record.id ? 'update_classroom_' + record.id : 'create_classroom_'
    const save = modelUtils.getModelEntity(classroom, key)
    const trainList = modelUtils.getModelEntity(trainCenter, 'classroom@trainCenterList')
    const load = modelUtils.getLoadingState(state, 'trainCenter')
    return {
        save,
        trainList,
        ...load
    }
}

export default connect(mapStateToProps)(ClassroomDetail)
